<img
  *ngIf="!zoomedIn else zoomed"
  #imageElement
  [src]="image.source"
  width="100%"
  alt="zoomable-image"
  [ngStyle]="{'cursor': zoomable ? 'zoom-in' : 'auto'}"
  class="img-zoomed-out"
  (click)="zoomable && zoomedInToggle()"
/>

<ng-template #zoomed>
    <slider-dialog-image-zoomed
      [image]="image"
      [clickPosX]="posX"
      [clickPosY]="posY"
      [containerWidth]="containerWidth"
      [containerHeight]="containerHeight"
      [factorX]="factorX"
      [factorY]="factorY"
      (click)="zoomable && zoomedInToggle()"
    ></slider-dialog-image-zoomed>
</ng-template>
